import React from 'react'
import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom'

import FertilityConsultationPage from '@progyny/pages/Consultations/Fertility/FertilityConsultationPage'
import MenopauseConsultationPage from '@progyny/pages/Consultations/Menopause/MenopauseConsultationPage'
import PostpartumConsultationPage from '@progyny/pages/Consultations/Postpartum/PostpartumConsultationPage'
import PregnancyConsultationPage from '@progyny/pages/Consultations/Pregnancy/PregnancyConsultationPage'
import Program from '@progyny/pages/Consultations/Program'
import ProgramInfo from '@progyny/pages/Consultations/ProgramInfo'
import SessionBooking from '@progyny/pages/Consultations/SessionBooking'
import {MENOPAUSE_PROGRAM_SLUG} from '@progyny/pages/Consultations/constants'
import {useMeStore} from '@progyny/store/meStore'
import {PREGNANCY_AND_POSTPARTUM, MENOPAUSE} from '@progyny/utils/constants'

const ConsultationsDefaultRedirect = () => {
  const user = useMeStore((s) => s.user)
  const productLine = user?.member?.activeMemberJourney

  if (productLine === PREGNANCY_AND_POSTPARTUM) {
    const status =
      user?.member?.pregnancyPostpartumJourney?.pregnancyPostpartumStatus
    if (status === 'postpartum') {
      return <Redirect to='/consultations/postpartum' />
    }
    return <Redirect to='/consultations/pregnancy' />
  }

  if (productLine === MENOPAUSE) {
    return <Redirect to='/consultations/menopause' />
  }

  return <Redirect to='/consultations/fertility' />
}

const Consultations = () => {
  let {url} = useRouteMatch()
  const user = useMeStore((s) => s.user)

  if (user?.member?.contractType === 'lite') {
    return <Redirect to='/404' />
  }

  return (
    <Switch>
      <Route
        path={`${url}/program/:program/info/:sessionid`}
        component={ProgramInfo}
      />
      <Route path={`${url}/program/:program/info/`} component={ProgramInfo} />
      <Route path={`${url}/program/:program/book`} component={SessionBooking} />
      <Route
        path={`${url}/program/${MENOPAUSE_PROGRAM_SLUG}/upcoming`}
        render={() => <Redirect to='/consultations/menopause/upcoming' />}
      />
      <Route
        path={`${url}/program/${MENOPAUSE_PROGRAM_SLUG}/past`}
        render={() => <Redirect to='/consultations/menopause/past' />}
      />
      <Route
        path={`${url}/program/${MENOPAUSE_PROGRAM_SLUG}`}
        exact
        render={() => <Redirect to='/consultations/menopause' />}
      />
      <Route path={`${url}/program/:program/upcoming`} component={Program} />
      <Route path={`${url}/program/:program/past`} component={Program} />
      <Route path={`${url}/program/:program`} component={Program} />
      <Route path={`${url}/pregnancy`} component={PregnancyConsultationPage} />
      <Route
        path={`${url}/postpartum`}
        component={PostpartumConsultationPage}
      />
      <Route path={`${url}/menopause`} component={MenopauseConsultationPage} />
      <Route path={`${url}/fertility`} component={FertilityConsultationPage} />
      <Route exact path={url} component={ConsultationsDefaultRedirect} />
    </Switch>
  )
}

export default Consultations
